import {
    videoSubmissionList,
    videoSubmissionByID,
} from '@/services/agency/videoSubmissions.service'

export default {
    namespaced: true,
    state: {
        videoSubmissionList: { meta: { pagination: { total: 0 } } },
        videoSubmission: {},
        videoSubmissionStatus: 'pending',
    },
    getters: {
        getVideoSubmissionList(state) { return state.videoSubmissionList },
        getVideoSubmission(state) { return state.videoSubmission },
        getVideoSubmissionStatus(state) { return state.videoSubmissionStatus },
    },
    mutations: {
        VIDEO_SUBMISSION_LIST(state, value) { state.videoSubmissionList = value },
        SET_VIDEO_SUBMISSION(state, value) { state.videoSubmission = value },
        VIDEO_SUBMISSION_STATUS(state, value) { state.videoSubmissionStatus = value },
    },
    actions: {
        async fetchVideoSubmissionList({ commit }, params) {
            window.scrollTo({ top: 0, behavior: 'smooth' })
            commit('VIDEO_SUBMISSION_STATUS', 'pending')
            commit('VIDEO_SUBMISSION_LIST', { meta: { pagination: { total: 0 } } })
            try {
                const { data } = await videoSubmissionList(params)
                commit('VIDEO_SUBMISSION_STATUS', 'init')
                commit('VIDEO_SUBMISSION_LIST', data)
                return data
            } catch (error) {
                commit('VIDEO_SUBMISSION_STATUS', 'init')
                throw error
            }
        },
        async fetchVideoSubmissionByID({ commit }, params) {
            commit('VIDEO_SUBMISSION_STATUS', 'pending')
            try {
                const { data } = await videoSubmissionByID(params)
                commit('VIDEO_SUBMISSION_STATUS', 'init')
                commit('SET_VIDEO_SUBMISSION', data.data)
                return data
            } catch (error) {
                commit('VIDEO_SUBMISSION_STATUS', 'init')
                return error
            }
        },
    },
}
